<script lang="ts">
  import QRCode from 'qrcode';
  import { SERVER } from '../lib/stores';

  let { paymentToken, priceSats, onClose }: { paymentToken: string; priceSats: number; onClose: () => void } = $props();

  let qrDataUrl = $state('');
  let copied = $state(false);

  $effect(() => {
    if (paymentToken) {
      QRCode.toDataURL(paymentToken, { width: 256, margin: 1, color: { dark: '#e6edf3', light: '#0d1117' } })
        .then((url) => { qrDataUrl = url; })
        .catch(() => {});
    }
  });

  function copyToken() {
    navigator.clipboard.writeText(paymentToken).then(() => {
      copied = true;
      setTimeout(() => { copied = false; }, 2000);
    });
  }
</script>

<svelte:window onkeydown={(e) => e.key === 'Escape' && onClose()} />

<div class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm">
  <div class="bg-[#161b22] border border-[#21262d] rounded-lg p-6 max-w-sm w-full" role="dialog" aria-modal="true" tabindex="-1">
    <div class="flex items-center justify-between mb-4">
      <h2 class="text-base font-bold text-[#e6edf3]">⚡ Pay {priceSats} sats</h2>
      <button onclick={onClose} class="text-[#8b949e] hover:text-[#e6edf3]">
        <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
          <path d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>

    <div class="text-center">
      {#if qrDataUrl}
        <img src={qrDataUrl} alt="Cashu payment QR" class="w-48 h-48 mx-auto rounded-lg border border-[#21262d]" />
      {:else}
        <div class="w-48 h-48 mx-auto rounded-lg border border-[#21262d] flex items-center justify-center">
          <div class="w-6 h-6 rounded-full border-2 border-[#21262d] border-t-[#58a6ff] animate-spin"></div>
        </div>
      {/if}

      <p class="text-xs text-[#8b949e] mt-3 mb-4">
        Scan with your Cashu wallet (Minibits, Enigma, etc.)
      </p>

      <div class="bg-[#0d1117] border border-[#21262d] rounded-md p-2 mb-3">
        <code class="text-[10px] text-[#3fb950] break-all select-all block">{paymentToken.slice(0, 60)}...</code>
      </div>

      <button
        onclick={copyToken}
        class="w-full px-3 py-2 text-xs font-medium rounded-md border border-[#21262d] bg-[#21262d] hover:bg-[#30363d] text-[#e6edf3] transition-colors"
      >
        {copied ? '✅ Copied!' : 'Copy Token'}
      </button>

      <p class="text-[10px] text-[#484f58] mt-3">
        Or paste the token into your wallet manually. Any Cashu mint is accepted.
      </p>
    </div>
  </div>
</div>
